import {withStyles} from '@/hocs/withStyles';
import {Noop} from '@/hocs/noop';
import styles from './styles.module.scss';
/**
 * Used in order to bundle everything together with a single component.
 * We can use this hoc in order to give padding or margin to each element passed, and avoid duplications.
 * */

const withIsPaddedRightMd = (Component = Noop) => withStyles(Component, styles, 'is-padded-r-md');
const withNoMarginBottom = (Component = Noop) => withStyles(Component, styles, 'no-margin-b');
const withMarginBottomXs = (Component = Noop) => withStyles(Component, styles, 'margin-b-xs');
const withMarginBottomSm = (Component = Noop) => withStyles(Component, styles, 'margin-b-sm');
const withMarginBottomMd = (Component = Noop) => withStyles(Component, styles, 'margin-b-md');
const withMarginBottomLg = (Component = Noop) => withStyles(Component, styles, 'margin-b-lg');
const withMarginBottomXl = (Component = Noop) => withStyles(Component, styles, 'margin-b-xl');
const withMarginBottomXxl = (Component = Noop) => withStyles(Component, styles, 'margin-b-xxl');
const withMarginBottom2xl = (Component = Noop) => withStyles(Component, styles, 'margin-b-2xl');
const withMarginBottomHuge = (Component = Noop) => withStyles(Component, styles, 'margin-b-huge');
const withMarginBottomZeroToSm = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-0-sm');
const withMarginBottomZeroToMd = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-0-md');
const withMarginBottomZeroToLg = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-0-lg');
const withMarginBottomZeroToXxl = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-0-xxl');
const withMarginBottom2xlToLg = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-2xl-to-lg');
const withMarginBottomLgToSm = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-lg-to-sm');
const withMarginBottomXlToSm = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-xl-to-sm');
const withMarginBottomDoubleXlToXl = (Component = Noop) =>
  withStyles(Component, styles, 'margin-b-double-xl-to-xl');
const withMarginTopSm = (Component = Noop) => withStyles(Component, styles, 'margin-t-sm');
const withMarginTopMd = (Component = Noop) => withStyles(Component, styles, 'margin-t-md');
const withMarginTopXl = (Component = Noop) => withStyles(Component, styles, 'margin-t-xl');
const withMarginTopDoubleLg = (Component = Noop) =>
  withStyles(Component, styles, 'margin-t-double-lg');
const withMarginTopZeroToMd = (Component = Noop) =>
  withStyles(Component, styles, 'margin-t-0-to-md');
const withMarginTopXlToZero = (Component = Noop) =>
  withStyles(Component, styles, 'margin-t-xl-to-0');
const withMarginTopZeroToSm = (Component = Noop) =>
  withStyles(Component, styles, 'margin-t-0-to-sm');
const withMarginTopZeroToXxl = (Component = Noop) =>
  withStyles(Component, styles, 'margin-t-0-to-xxl');
const withMarginLeftXs = (Component = Noop) => withStyles(Component, styles, 'margin-l-xs');
const withMarginLeftXl = (Component = Noop) => withStyles(Component, styles, 'margin-l-xl');
const withMarginRightSectionToZero = (Component = Noop) =>
  withStyles(Component, styles, 'margin-r-section-t-0');
const withMarginTopAdBanner = (Component = Noop) =>
  withStyles(Component, styles, 'margin-top-ad-banner');

export {
  withIsPaddedRightMd,
  withNoMarginBottom,
  withMarginBottomXs,
  withMarginBottomSm,
  withMarginBottomMd,
  withMarginBottomLg,
  withMarginBottomXl,
  withMarginBottom2xl,
  withMarginBottomXxl,
  withMarginBottomHuge,
  withMarginBottomZeroToSm,
  withMarginBottomZeroToMd,
  withMarginBottomZeroToLg,
  withMarginBottomZeroToXxl,
  withMarginBottom2xlToLg,
  withMarginBottomLgToSm,
  withMarginBottomXlToSm,
  withMarginBottomDoubleXlToXl,
  withMarginTopSm,
  withMarginTopMd,
  withMarginTopXl,
  withMarginTopDoubleLg,
  withMarginTopZeroToMd,
  withMarginTopXlToZero,
  withMarginTopZeroToSm,
  withMarginTopZeroToXxl,
  withMarginLeftXs,
  withMarginLeftXl,
  withMarginRightSectionToZero,
  withMarginTopAdBanner
};
